import React, { Component } from "react";
import PropTypes from "prop-types";

import "./App.css";
import IronSourceInitializerContainer from "./package-ironsource/containers/IronSourceInitializerContainer";
import PageTransitionSequence from "./components/PageTransitionSequence";
import RewardAdContainer from "./package-reward-ads-overlay/containers/RewardAdContainer";
import AudioContainer from "./containers/AudioContainer";
import { playSound } from "./utils/audio-helper";
import { GAME_STATUS_HINT_CLICK, GAME_STATUS_REVEAL_ALL_ANSWERS_CLICK } from "./actions/game";
import AnalyticsContainer from "./containers/AnalyticsContainer";
import { getTodayGameStats } from "./utils/localStorage";

class App extends Component {
  constructor(props) {
    super(props);
    const self = this,
      gameStats = getTodayGameStats();;
// console.log('gameStats', gameStats && gameStats.GAME_STATUS);
    self.state = {
      gameStatus: (gameStats && gameStats.GAME_STATUS) || null 
    };
  }

  renderReward() {
    if (this.props.shouldRewardPoints) {
      console.log("this.renderReward");
      return <RewardAdContainer
        showVideoAd={true}
        handleVideoOverlayClose={()=>{
          this.props.addGamePoints(200);
          this.props.setShouldRewardPoints(false);
          this.props.setGameAwardRewardStatus();
        }} 
        handleExitShowVideoAd={()=>{
           this.props.setShouldRewardPoints(false);
        }}
        videoAdType={'test'}
        showNewsletter={true}
        />
    }

    if (this.props.gameStatus === GAME_STATUS_HINT_CLICK || this.props.gameStatus === GAME_STATUS_REVEAL_ALL_ANSWERS_CLICK) {
      return <RewardAdContainer
        showVideoAd={true}
        handleVideoOverlayClose={()=>{
          this.props.setGameAwardRewardStatus();
        }} 
        handleExitShowVideoAd={()=>{
          this.props.resetGameStatus();
        }}
        videoAdType={'test'}
        showNewsletter={true}
        />
    }
  }

  componentDidMount() {
    const self = this,
      gameStats = getTodayGameStats();

    // console.log("quizQuestions:", self.props.quizQuestions);
    self.props.setGameData(self.props.quizQuestions);
    // console.log('gameStats', gameStats);
    if (gameStats && gameStats.GAME_STATUS) {
      this.props.setGameStatus(gameStats.GAME_STATUS)
    }
  }
  
  
  componentDidUpdate(prevState, prevProps) {
    
    if (this.props.sounds !== [] && prevProps.sounds !== this.props.sounds) {
      // playSound(this.props.sounds, 'theme');
		}
	}

  render() {
    console.log('this.state.gameStatus', this.state.gameStatus);
    return (
      <div id="app-container">
        <PageTransitionSequence 
          sounds={this.props.sounds} 
          startingPage={(this.state.gameStatus === null && 'landing') || 'results'}
          />
        {this.renderReward()}
        <AudioContainer />
        <AnalyticsContainer />
        <footer>
          <div className="legal">
          NO PURCHASE NECESSARY TO ENTER OR WIN.  A PURCHASE WILL NOT IMPROVE YOUR CHANCES OF WINNING.  Promotion consists of an Instant Win Game and a Sweepstakes and begins on or about Saturday, February 18, 2023 at 12:00:01 a.m. Pacific Time (“PT”) and ends on Friday, March 17, 2023 at 11:59:59 p.m. PT.  Must be 18 or older. See Official Rules at  <a href="https://www.gameshownetwork.com/switch/rules" target="_top">https://www.gameshownetwork.com/switch/rules</a> for complete information, including how to enter and play, eligibility restrictions, prize descriptions/restrictions/ARVs and complete details.  Void where prohibited.  Sponsored by Game Show Network, LLC, 2150 Colorado Avenue, Suite 100, Santa Monica, California 90404.  
          </div>
        </footer>
      </div>
    );
  }
}

App.propTypes = {
  angle: PropTypes.number.isRequired,
  quizQuestions: PropTypes.array.isRequired,
  gameData: PropTypes.array.isRequired,
  setGameData: PropTypes.func.isRequired,
  randomizedGameData: PropTypes.func.isRequired
};

export default App;
